import {
  deliveryEstimateSelectorSchema,
  SelectorType,
} from "@redotech/redo-model/conversion/storefront-delivery-estimate";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const addStorefrontDeliveryEstimateSelector = {
  name: "addStorefrontDeliveryEstimateSelector" as const,
  input: z.object({
    selector: deliveryEstimateSelectorSchema.omit({ _id: true }),
    selectorType: createEnum(SelectorType),
  }),
  output: z.null(),
};
